<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header" class="row">
        <h3 class="col-lg-12" style="padding:0px;">Nova inscrição</h3>
      </div>

      <div slot="body" style="margin:0px;">
        <div class="control-group">
          <label class="control-label" for="status">Produto *</label>
          <select
            :class="{ 'has-error': $v.subscription.productId.$error }"
            v-model="subscription.productId"
            id="status"
            class="form-control"
          >
            <option disabled value>Escolha um produto</option>
            <option v-for="p in products" v-bind:key="p.id" v-bind:value="p.id">{{p.name}}</option>
          </select>
        </div>
      </div>

      <div slot="footer">
        <lms-button :disabled="false" @click="save()" :loading="saving">Salvar</lms-button>
        <!-- <button class="btn btn-default" @click="saveVideos()">Salvar</button> -->
        <lms-button :danger="true" :disabled="false" @click="close()" :loading="saving">Cancelar</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 2s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 2s;
}
.v-enter-to {
  opacity: 1;
}

input[type="text"],
input[type="date"],
input[type="datetime"],
input[type="number"],
input[type="search"],
input[type="time"],
input[type="url"],
input[type="email"],
textarea,
select {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  border: 1px solid #bebebe;
  padding: 7px;
  margin: 0px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
}
input[type="text"]:focus,
input[type="date"]:focus,
input[type="datetime"]:focus,
input[type="number"]:focus,
input[type="search"]:focus,
input[type="time"]:focus,
input[type="url"]:focus,
input[type="email"]:focus,
textarea:focus,
select:focus {
  -moz-box-shadow: 0 0 8px #88d5e9;
  -webkit-box-shadow: 0 0 8px #88d5e9;
  box-shadow: 0 0 8px #88d5e9;
  border: 1px solid #88d5e9;
}

.custom-grid-modal-2 {
  grid-template-columns: 0.3fr 0.3fr 1.5fr 0.3fr !important;
}

.custom-grid-modal {
  grid-template-columns: 0.3fr 1fr 0.3fr 0.3fr 0.3fr !important;

  @media (max-width: 768px) {
    grid-template-columns: 1fr !important;
  }
}
.btn-add-custom {
  @media (min-width: 768px) {
    display: none;
  }
}

.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>


<script>
import axios from "axios";
import { required, minLength } from "vuelidate/lib/validators";

export default {
  props: {
    userId: {
      type: Number,
      required: true
    }
  },
  validations: {
    subscription: {
      productId: { required }
    }
  },
  data() {
    return {
      subscription: {},
      products: [],
      saving: false
    };
  },
  methods: {
    save() {
      const path = this.$global.endpoint + "/subscription/new";
      axios
        .post(path, {
          productId: this.subscription.productId,
          userId: this.userId
        })
        .then(res => {
          this.$notify({
            type: "success",
            group: "foo",
            title: "Concluído",
            text: "Inscrição adicionada"
          });
          this.$emit("saved");
          this.$emit("close");
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: "Erro ao salvar a inscrição"
          });
        });
    },

    close() {
      this.$emit("close");
    },
    getAllProducts() {
      const path = this.$global.endpoint + "/product/getall";
      axios
        .post(path, { limit: 1000, page: 0 })
        .then(res => {
          this.products = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    this.getAllProducts();
  }
};
</script>
